// extracted by mini-css-extract-plugin
export default {"card":"Login_card__Gw9+E","form":"Login_form__hccai","form__input":"Login_form__input__vZXA7","form__button":"Login_form__button__Xsjy2"};